export interface PresenterState<TInput = void> {
  visible: boolean;
  rendered: boolean;
  inputData: TInput | undefined;
}

export enum PresenterOutputType {
  Resolve = 'resolve',
  Reject = 'reject',
}

export interface PresenterResolution<TOutput = void> {
  type: PresenterOutputType.Resolve,
  output: TOutput;
}

export interface PresenterRejection {
  type: PresenterOutputType.Reject,
}

export type PresenterResult<TOutput = void> = PresenterResolution<TOutput> | PresenterRejection;

export function getDefaultPresenterState<TInput>(): PresenterState<TInput> {
  return {
    visible: false,
    rendered: false,
    inputData: undefined,
  };
};
